var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3 bg-secondary-3 px-4 py-2 rounded" }, [
    _c("div", { staticClass: "row p-3" }, [
      _c("div", { staticClass: "col-md-4 p-0" }, [
        _c("div", { staticClass: "color-secondary-6 font-14" }, [
          _vm._v("Título:")
        ]),
        _c("div", { staticClass: "color-black font-14" }, [
          _vm._v(_vm._s(_vm.value.title))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-3 p-0" },
        [
          _c("div", { staticClass: "color-secondary-6 font-14" }, [
            _vm._v("Aplica a Proveedor:")
          ]),
          _vm.isEditing
            ? _c("custom-radio", {
                staticClass: "custom-radio__extended",
                attrs: {
                  id: `providerApplicationRb-${_vm.value.proposalDocumentTypeId}`,
                  "custom-error-msg": "Favor seleccione",
                  "is-inline": "",
                  name: `providerApplicationRb-${_vm.value.proposalDocumentTypeId}`,
                  options: _vm.applicationProviderOptions
                },
                model: {
                  value: _vm.model.providerApplication,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "providerApplication", $$v)
                  },
                  expression: "model.providerApplication"
                }
              })
            : _c("div", { staticClass: "color-black font-14" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.parseProviderApplication(
                        _vm.value.providerApplication
                      )
                    ) +
                    " "
                )
              ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-3 p-0" },
        [
          _c("div", { staticClass: "color-secondary-6 font-14" }, [
            _vm._v("Requerido:")
          ]),
          _vm.isEditing
            ? _c("custom-radio", {
                staticClass: "custom-radio__extended",
                attrs: {
                  id: `isRequiredRb-${_vm.value.proposalDocumentTypeId}`,
                  "custom-error-msg": "Favor seleccione",
                  "is-inline": "",
                  name: `isRequiredRb-${_vm.value.proposalDocumentTypeId}`,
                  options: _vm.requiredOptions
                },
                model: {
                  value: _vm.model.required,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "required", $$v)
                  },
                  expression: "model.required"
                }
              })
            : _c("div", { staticClass: "color-black font-14" }, [
                _vm._v(" " + _vm._s(_vm.value.required ? "Si" : "No") + " ")
              ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2 p-0 text-right" },
        [
          !_vm.readOnly && !_vm.draggableEnabled
            ? [
                _vm.canEditDocuments && !_vm.isEditing
                  ? _c("action-button", {
                      staticClass: "mr-2",
                      attrs: {
                        i: "fa fa-times-circle",
                        variant: "outline-danger"
                      },
                      on: { click: _vm.onDeleteHandler }
                    })
                  : _vm._e(),
                _vm.canEditDocuments && !_vm.isEditing
                  ? _c("action-button", {
                      attrs: { i: "fa fa-edit", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.onEditHandler()
                        }
                      }
                    })
                  : _vm._e()
              ]
            : _vm.draggableEnabled
            ? [
                _c("i", { staticClass: "fas fa-ellipsis-v" }),
                _c("i", { staticClass: "fas fa-ellipsis-v" })
              ]
            : _vm._e()
        ],
        2
      )
    ]),
    _vm.isEditing
      ? _c("div", { staticClass: "row p-3" }, [
          _c("div", { staticClass: "col-md-12 p-0" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v("Descripción:")
            ]),
            _c("div", { staticClass: "color-black font-14" }, [
              _vm._v(_vm._s(_vm._f("empty")(_vm.value.description)))
            ])
          ])
        ])
      : _vm._e(),
    _vm.isEditing
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c("action-button", {
              attrs: {
                i: "fas fa-times-circle",
                text: "Cancelar",
                variant: "outline-danger mr-3 pl-3 pr-4"
              },
              on: { click: () => (_vm.isEditing = false) }
            }),
            _c("action-button", {
              attrs: {
                i: "fas fa-save",
                text: "Guardar",
                variant: "success pl-3 pr-3"
              },
              on: { click: _vm.onSaveDocumentHandler }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }